import { useState, useContext } from 'react'
import { BookingContext } from "../context";
import GeneralFields from '../GeneralFields'
import EventFields from '../EventFields'
import TicketRow from '../TicketRow'

import cn from 'classnames'
import styles from './index.module.scss'


export default function TicketVariation({ variation, fields, onExpand, expanded }) {

    let [quantity, setQuantity] = useState(1)
    const { customer } = useContext(BookingContext)
    
    const increase = () => {
        setQuantity(quantity + 1)
    }

    const decrease = () => {
        setQuantity(quantity - 1)
    }

    //const companyTypes = ['Academic', 'Association', 'Broker / Dealer', 'Clearing House', 'Consultant', 'Custodian / Fund Administration', 'Exchange', 'Hedge Funds / Proprietary Traders', 'Insurance / Plan Sponsor', 'Investment Bank', 'Investment Management', 'Legal', 'Marketing Agency / PR', 'Media', 'Non-Financial', 'Recruitment', 'Regulator', 'Retail Bank', 'Vendor - Data', 'Vendor - Infrastructure', 'Vendor - Software', 'Venture Capital / Private Equity']

    let bottom = (            
        <div className={styles.bottom}>

            {!customer ? <><hr /><GeneralFields /></> : <></>}

            <EventFields />

            <hr />
            
            <div className={styles.select}>
                <input type="hidden" name={`variations[${variation.variation_id}]`} value={quantity} />
                <span className={styles.selectTitle}>Please select the quantity of tickets</span>
                <div className={styles.selector}>
                    <button type="button" onClick={() => decrease()} className={cn(styles.buttonMath, styles.buttonMinus)}><svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="#fff" stroke-width="1.5" d="M.722 1.25h8.179"></path></svg></button>
                    <span className={styles.controlValue}>{quantity}</span>
                    <button type="button" onClick={() => increase()} className={cn(styles.buttonMath, styles.buttonPlus)}><svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="#fff" stroke-width="1.5" d="M.695 4.25h8.179M4.489 9V0"></path></svg></button>
                </div>
            </div>
            

            <div className={styles.rows}>
                {[...Array(quantity).keys()].map((row, index) => (
                    <TicketRow index={index} row={row} fields={fields} />
                ))}
            </div>


            <button type="submit" className={styles.submit}>Book now</button>

        </div>
    )


    return (
        <div className={cn(styles.variation, expanded && styles.selected)} onClick={() => onExpand()}>
            <div className={styles.box}>
                <div className={styles.left}>
                    <div className={styles.name}>{variation.attributes['attribute_ticket-type']}</div>
                    <div className={styles.price} dangerouslySetInnerHTML={{ __html: variation.price_html + ((variation.tax_class !== 'zero-rate' && variation.display_price > 0) ? ' + 20% VAT' : '') }}></div>
                    <div className={styles.desc} dangerouslySetInnerHTML={{ __html: variation.variation_description }}></div>
                </div>
                <div className={styles.right}>
                    <button type="button" className={styles.expandedStatus}>{expanded ? 'SELECTED' : 'SELECT'}</button>
                </div>
            </div>

            {expanded ? bottom : null}
        </div>
    )
        
}